import React from "react";

const PageViews = React.lazy(() => import("./index"));

export default [{ path: "/page_views", component: PageViews, name: "Page Views" }];
